<template>
<div>
	<common-top :commonTopData="commonTopData"></common-top>
	<div class="wh Detail">
		<div class="detailtitle ofh relative">
			<span class="fleft worktabs">
				{{ currentpageName }}
			</span>
		</div>
		<div class="detailContent1 ofh">
			<ul>
				<li class="margint13 ofh">
					<span class="fleft roles-input fontcolorg" style="margin-right: 20px;">{{release_data.title_name}}：</span>
					<div class="el-input__inner roles-input width500">
						<input type="text" placeholder="请输入内容" class="sel-input fleft" maxlength="30" @input="getleng(10)" v-model="text10">
						<span class="fright">{{ text10.length }}/30</span>
					</div>
				</li>
				<li class="margint13 ofh">
					<span class="fleft fontcolorg" style="margin-right: 20px;">{{release_data.content_name}}：</span>
					<div style="margin-left: 77px;">
						<vue-ueditor-wrap :config="myConfig" @ready="ready" v-model="text100"></vue-ueditor-wrap>
					</div>
					
					<!-- <div class="fleft defaultbtnworkbg">
						<div>
							<textarea style="padding: 10px;" name="" id="" cols="69" rows="10" v-model="text100"  class="defaultbtnwork"></textarea>
						</div>
						<span class="fright fontcolorg">{{ text100.length }}/100</span>
					</div> -->
				</li>
				<li class="margint13 ofh" v-if="is_hf">
					<span class="fleft fontcolorg" style="margin-right: 20px;">反馈问题：</span>
					<div class="fk_box" style="margin-left: 77px;">
						{{ hfVal.detail }}
					</div>
				</li>
				<li class="margint13 ofh">
					<span class="fleft fontcolorg" style="margin-right: 10px;">发送用户：</span>
					<div v-if="is_hf">{{ hfVal.username || hfVal.open_id}}</div>
					<button v-else class="defaultbtn" style="margin: 0;" @click="dialogTable">选择通知用户：</button>
					<div>
						<span class="fleft fontcolorg" style="margin-right: 20px;width: 56px;height: 40px;"></span>
						<span class="fleft fontcolorg" style="margin-top: 10px;">已选择的通知用户数：{{ sendnum }}</span>
					</div>
				</li>
				<li class="margint13 ofh" v-if="!is_hf">
					<span class="fleft fontcolorg" style="margin-right: 20px;">发布时间：</span>
					<el-date-picker class="fleft" value-format="yyyy-MM-dd HH:mm:ss" v-model="send_time" type="datetime"
					 placeholder="开始时间">
					</el-date-picker>
				</li>
				<li  class="margint13 ofh opxcf_00c1">
					<span class="fleft fontcolorg" style="margin-right: 20px;">全站发送：</span>
					<div>
						<el-radio-group v-model="all_user" :disabled="is_hf?true:false">
							<el-radio :label="1">全站发送</el-radio>
							<el-radio :label="2">全站供稿人发送</el-radio>
							<el-radio :label="''">不全站发送</el-radio>
				
						</el-radio-group>
					</div>
				</li>
			</ul>
		</div>
		<el-dialog title="请选择通知人员" :visible.sync="dialogTableVisible" custom-class="sel-dialog">
			<div style="height: 620px;overflow-y: scroll;" class="relative">	
				<div class="margin40 borderb" style="position: relative;padding-bottom: 22px;">
					<div class="ofh">
						<div class="fleft">
							<el-button class="btnorgle" v-for="(item,index) in commonTopData.commonleftbtn" :key="item.id" @click="screen(item.id)">{{ item.name }}</el-button>
						</div>
					</div>
				</div>
				
				<div class="calc205 ofv">
					<common-table @seletFn="seletFn" :config="config" :screenConfig="screenConfig" :tableConfig="tableConfig" :tableDatas="tableData" :tableAction="tableAction"
					 ref="Tabledd"></common-table>
				</div>
				
			</div>
		</el-dialog>
		<div class="screenContent detailbtn">
			<button class="defaultbtn" @click="getparent()">返回</button>
			<button class="defaultbtn defaultbtnactive" v-if="!rows.id" @click="add()">{{is_hf?'回复':'创建'}}</button>
			<button class="defaultbtn defaultbtnactive" v-if="rows.id" @click="edit()">保存</button>
		</div>
		<common-screen :pageName="pageName" :show="IsScreen == 'No'"></common-screen>
	</div>
</div>
</template>

<script>
    import VueUeditorWrap from 'vue-ueditor-wrap'
	import workData from "../../assets/workData.js"
	import commonTop from '@/components/commonTop.vue'
	import commonTable from '@/components/commonTableAll2.vue'
	import DataScreen from "@/assets/DataScreen.js"
	export default {
		components: {
			commonTop,
			commonTable,
			VueUeditorWrap,
		},
		data() {
			return {
				config:{
					ajax:{
						url:'getUserList'
					},
					prop:'open_id',
					propData:[],
				},
				
				
				currentpageName:"",
				pageName: "addrelease",
				tableAction: DataScreen.screenShow.addrelease.action,
				filterFields: DataScreen.screen.addrelease.filterFields,
				dialogTableVisible: false,
				textarea: '',
				commonTopData: {
					"pageName": "addrelease",
					"commonleftbtn": [{
							name: "筛选",
							id: "left1",
							url: ""
						}
					],
					"commonrightbtn": [],
					"commonbottombtn": [],
				},
				myConfig: {
					autoHeightEnabled: false,
					initialFrameHeight: 250,
					initialFrameWidth: 500,
					UEDITOR_HOME_URL: '/UEditor/'
				},
				screenConfig: [],
				tableConfig: {
					"pageName": "addrelease",
					total: 0,
					currentpage: 1,
					pagesize: 10,
					list: DataScreen.screenShow.addrelease.bts,
					ischeck: true,
					loading:true,
					masktoast:true

				},
				tableData: [],
				IsScreen: "Off",
				work_info: {},
				selectData:[],
				text10:"",
				text100:"",
				send_time:"",
				rows:{},
				sendnum:0,
				to_open_ids:'',
				all_user:'',
				hfVal:{},
				release_data:{
					title_name:'通知标题',
					content_name:'通知内容'
				},
				is_hf:false,
			}
		},
		methods: {
			getparent() {
				//alert(parseInt(this.$route.query.type))
				this.$router.go(-1);

			},
			getleng(n) {
				if (n == 10) {
					this.length10 = this.text10.length
				} else if (n == 30) {
					this.length30 = this.text30.length
				}
			},
			getValue(val) {
				if (val) {
					return val
				} else {
					return "--"
				}
			},
				
			seletFn(row){
				console.log(row,'row')
				this.dialogTableVisible=false;
				this.sendnum=row.length;
				this.to_open_ids = row.join(',');
			},
			screen(id) {
				if (id = "left1") {
					this.IsScreen = "No";
				}
			},
			screenmask(data, n) {
				this.pageName = "";
				switch (n) {
					case "left1":
						this.IsScreen = data;
						break;
					default:
						break;
				}

			},
			getworkdetial() {
				this.api.workInfo({
					work_id: this.$route.query.id,
					access_token: localStorage.getItem("access_token")
				}).then(da => {
					//console.log(da)
					this.work_info = da.work_info;
				}).catch(da => {

				})
			},
			getnoticeids() {
			
				var openids = '';
				this.selectData.forEach((item, index) => {
					openids += (index == (this.selectData.length - 1)) ? item.open_id : item.open_id + ",";
				})
				return openids;
			},
			setLoding(type){
				//alert(2);
				this.$refs.Tabledd.setLoding(type);	
			},
			
			getScreenShowData() {
				//获取字段展示-筛选修改
				eventBus.$on("screenShowDataChange", (data) => {
					this.tableConfig.list = [];
					this.forshowkey(data)
				});
			
				//获取字段展示-筛选初始化
				if (localStorage.getItem("screenShowDataChange")) {
					this.forshowkey(localStorage.getItem("screenShowDataChange").split(','))
				} else {
					this.forshowkey(this.defaultbts);
				}
			},
			forshowkey(data) {
				//筛选展示字段
				this.bts.forEach(item => {
					const val = item;
					data.forEach(item1 => {
						if (val.prop == item1) {
							this.tableConfig.list.push(val)
						}
					})
				})
			},
			screenreach() {
				eventBus.$on("sreenData", (data) => {
					this.getcommonrightbtn();
		
				})
			},
			linkDetail(id) {
				//alert(id);
				this.IsDetail = true;
				this.api.getUserInfo({
					open_id: id
				}).then(da => {
					this.detailData = da;
				}).catch(() => {
			
				})
			},
			setContributor(val) {
				this.selectOne = val;
				this.centerDialogVisible1 = true;
			},
			getworkids() {
				//console.log(this.selectData);
				var workids = '';
				this.selectData.forEach((item, index) => {
					workids += (index == (this.selectData.length - 1)) ? item.work_id : item.work_id + ",";
				})
				if (this.centerDialogVisible) {
					workids = workids
				}
			
				if (this.centerDialogVisible1) {
					workids = this.selectOne.work_id;
				}
				return workids;
			},
			getcommonrightbtn(){
				this.commonTopData.commonbottombtn = [];
				if(this.$route.query.urlDate){
					const urldata = JSON.parse(this.$route.query.urlDate);
					//console.log(urldata);
					this.filterFields.forEach(item=>{
						//console.log(item);
						if(urldata[item.id]){
							var val = urldata[item.id];
							if(item.child){	
								val = "";
								item.child.forEach(citem=>{
									//alert(urldata[item.id])
									if(citem.id == urldata[item.id]){
										val = citem.name;
									}
								})
							} 
							this.commonTopData.commonbottombtn.push({btnName:item.name,val:val,id:item.id});
							//console.log(this.commonTopData.commonbottombtn);
						} 
						if(item.type == "two"){
							if(item.child){
								item.child.forEach(citem=>{
									if(urldata[citem.id]){
										this.commonTopData.commonbottombtn.push({btnName:citem.name,val:urldata[citem.id],id:citem.id})
									}
								})
							}
						}
						if(item.type == "time"){
							if(item.child){
								item.child.forEach(citem=>{
									if(urldata[citem.id]){
										this.commonTopData.commonbottombtn.push({btnName:citem.name,val:urldata[citem.id],id:citem.id})
									}
								})
							}
						}
					})
				}
			},
			resetSave(tag){
				if(this.$route.query.urlDate){
					const urldata = JSON.parse(this.$route.query.urlDate)
					delete urldata[tag];
					this.$router.push({path:'/noticeManager/newsRelease/editrelease',query:{urlDate:JSON.stringify(urldata)}});
				}
			},
			dialogTable(){
				this.dialogTableVisible = !this.dialogTableVisible;
			},
			timestampToTime(timestamp) {
				// 时间戳为10位需*1000，时间戳为13位不需乘1000
				// var date = new Date(timestamp * 1000);
				var date = new Date(timestamp);
				var Y = date.getFullYear() + "-";
				var M =
					(date.getMonth() + 1 < 10
					? "0" + (date.getMonth() + 1)
					: date.getMonth() + 1) + "-";
				var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
				var h = date.getHours() + ":";
				var m = date.getMinutes() + ":";
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			},

			add(){
				//如果是回复反馈功能就自动提交当前一分钟后的时间
				if(this.is_hf){
					let timestamp = Date.now(); // 获取当前时间戳  
					// 将时间戳增加一分钟  
					timestamp += 60 * 1000; // 60 秒 * 1000 毫秒/秒  
					this.send_time = this.timestampToTime(timestamp)
				}
				
				// console.log(
				// 	{
				// 		access_token:localStorage.getItem("access_token"),
				// 		title:this.text10,
				// 		content:this.text100,
				// 		to_open_ids:this.to_open_ids,
				// 		send_time:this.send_time,
				// 		all_user:this.all_user
				// 	}
				// )
				this.api.addnotice({
					access_token:localStorage.getItem("access_token"),
					title:this.text10,
					content:this.text100,
					to_open_ids:this.to_open_ids,
					send_time:this.send_time,
					all_user:this.all_user
				}).then(da => {
					if(da.result == 0){
						if(this.is_hf){
							this.api.admin_feedback_fix({
								access_token:localStorage.getItem("access_token"),
								feedback_id:this.hfVal.feedback_id,
								feedback_reply:JSON.stringify({title:this.text10,content:this.text100,})
							}).then(da => {
								console.log('更新成功')
							})
							this.$message({
								message: '回复成功',
								type: 'success'
							});
							this.$router.push({
								path:'/otherInformation/feedback'
							})
						}else{
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$router.push({
								path:"/noticeManager/newsRelease"
							})
						}
					}
				}).catch(() => {
							
				})
			},
			edit(){
				let data ={
					access_token:localStorage.getItem("access_token"),
					id:this.rows.id,
					all_user:this.all_user,
				}
				
				if(this.text10){
					data.title=this.text10;
				}
				if(this.text100){
					data.content=this.text100;
				}
				if(this.to_open_ids){
					data.to_open_ids=this.to_open_ids;
				}
				if(this.send_time){
					data.send_time=this.send_time;
				}
				
				this.api.noticeedit(data).then(da => {
					if(da.result == 0){
						this.$router.go(-1);
					}
				}).catch(() => {
							
				})
			},
			setchange(){
				this.dialogTableVisible=false;
				this.sendnum=this.selectData.length;
				this.to_open_ids = this.getnoticeids();
			},
			ready(editorInstance) {
				this.uD = editorInstance;
				editorInstance.addListener('focus', (editor) => {
					if (this.ifBjType == 0) {
						this.form.info = '';
						this.ifBjType = 1;
					}
				});
				editorInstance.addListener('blur', (editor) => {
					if (this.ifBjType == 1 && this.form.info == '') {
						this.form.info = '';
						this.ifBjType = 0;
					}
				});
			
			},
			

		},
		created() {
			//this.getworkdetial();
		
			this.screenreach();
			this.getcommonrightbtn();
			
			
		},
		mounted(){
			
			if(this.$route.query.hfVal){
				this.hfVal = JSON.parse(this.$route.query.hfVal)
				console.log(this.hfVal,'this.hfVal')
				this.release_data = {
					title_name:'回复标题',
					content_name:'回复内容'
				}
				this.sendnum=[this.hfVal.open_id].length;
				this.to_open_ids = [this.hfVal.open_id].join(',');
				this.is_hf =true
			}else{
				this.release_data = {
					title_name:'通知标题',
					content_name:'通知内容'
				}
				this.is_hf = false
			}

			this.currentpageName = (this.$route.matched[this.$route.matched.length-1].meta.title).split("/")[1];
			if(this.$route.query.row){
				this.rows = JSON.parse(this.$route.query.row);
				this.text10 = this.rows.title;
				this.text100 = this.rows.content;
				this.send_time=this.rows.send_time;
				this.sendnum = this.rows.send_num;
				this.to_open_ids = this.rows.to_open_ids;
				this.all_user = this.rows.all_user;
				this.config.propData = this.rows.to_open_ids.split(',');
				localStorage.setItem("addrelease",this.$route.query.row);
			} else {
				if(this.currentpageName == "新建通知"){
					if(localStorage.getItem("addrelease")){
						this.rows = JSON.parse(localStorage.getItem("addrelease"));
						this.text10 = this.rows.title;
						this.text100 = this.rows.content;
						this.send_time=this.rows.send_time;
						this.sendnum = this.rows.send_num;
						this.to_open_ids = this.rows.to_open_ids
					}
				}
				
			}
		
		},
		watch:{
			"$route":function(){
				this.screenreach();
				this.getcommonrightbtn();
			
			}
		}
	}
</script>

<style>
	.materiallist .el-checkbox__label {
		display: none;
	}

	.paddingb10 {
		padding-bottom: 10px;
	}

	.padding10 {
		padding: 10px 0;
	}

	/* .cttitle {
		line-height: 60px;
		padding-bottom: 20px;
	} */

	.tagbts {
		display: flex;
		align-items: center;
		height: 100%;
		/* overflow-x: auto; */
	}

	.lefttit {
		position: absolute;
		height: 60px;
		line-height: 60px;
		left: 40px;
	}

	.badge .el-badge__content.is-fixed {
		top: 13px
	}
	
	.sel-dialog  {
		width: 1000px;
	}
	
	.shelves .el-message-box__content{
		border-top:0 !important;
	}
</style>

<style scoped>
	.Detail {
		background: white;
	}

	.Dialogkey {
		margin: 0 33px 26px 66px;
		width: 84px;
	}

	.detailtitle {
		padding-left: 40px;
		padding-top: 18px;
	}

	.detailContent1 {
		height: calc(100% - 139px);
		overflow-y: auto;
	}

	.detailContent1>ul {
		padding-left: 132px;
		padding-top: 64px;
	}

	.margint13 {
		margin-bottom: 13px;
	}

	.detailKey {
		width: 160px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #999999;
	}

	.detailValueImg {
		width: 68px;
		height: 68px;
		border-radius: 50%;
		background: red;
	}

	.detailKeyImg {
		line-height: 68px;
	}

	.routerLink {
		color: #FF5121;
	}

	.detailbtn {
		height: 100px;
	}

	.squareImg {
		width: 160px;
		height: 102px;
		background: red;
	}

	.roles-input {
		height: 40px;
		line-height: 40px;
	}

	.width500 {
		width: 500px;
	}

	.roles-input input {
		height: 100%;
		width: 400px;
	}

	.roletree {
		height: 460px;
		border: 1px solid #D9D9D9;
		display: inline-block;
		overflow-y: auto;
		border-radius: 5px;
	}

	.account-ipt {
		padding: 10px;
		text-align: center;
		border: 1px solid #999999;
		border-radius: 5px;
	}

	.materiallist {
		display: flex;
		overflow: hidden;
		flex-wrap: wrap;
		justify-content: flex-start
	}

	.materiallist li {
		margin: 0 17px 17px 0;
	}

	.material {
		width: 239px;
		height: 135px;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.10);
		border-radius: 5px;
		background: #F9F9F9;
	}

	.material-fu {
		width: 60px;
		height: 68px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -34px;
		margin-left: -30px;
	}

	.material-bo {
		width: 32px;
		height: 32px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -16px;
		margin-left: -16px;
	}

	.material-checkbox {
		position: absolute;
		top: 6px;
		right: 10px;
	}

	.materialdownload {
		position: absolute;
		top: 10px;
		right: 10px;
	}

	.color66 {
		color: #666666;
		margin-top: 3px;
		overflow: hidden;
		font-size: 14px;
	}

	.el-message-box--center .el-message-box__title {
		justify-content: left;
	}

	.sel-alert {
		width: 406px;
	}

	.el-dialog__title {
		font-size: 16px !important;
	}

	.el-dialog__body {
		padding: 27px 0 27px !important;
		border-top: 1px solid #e6e6e6;
	}

	.el-radio-group {
		display: block;
	}

	.el-dialog__headerbtn {
		position: "";
		float: right;
		font-size: 18px;
	}

	.sel-footer {
		display: block;
		text-align: center;
	}

	.el-radio {
		line-height: 28px;
	}

	[class*=" el-icon-"],
	[class^=el-icon-] {
		line-height: 2;
	}

	.sel-radio-title {
		position: absolute;
		left: 30px;
	}

	.font12 {
		font-family: PingFangSC-Regular;
		font-size: 12px;
		color: #999999;
	}

	.el-message-box--center .el-message-box__content {
		padding: 20px 0 37px;
		border-top: 1px solid #E6E6E6;
	}

	.workbtn {
		width: 70px;
	}

	.employipt {
		height: 40px;
		line-height: 40px;
		margin: 30px;
	}

	.employmonre {
		width: 300px;
		display: inline-block;
		margin: 0 20px;
	}

	.employmonre input {
		width: 200px;
		height: 100%;
		margin-left: 5px;
	}
	
	.opxcf_00c1{
		display: flex;
		flex-direction: row;
	}
	.fk_box{
		border:1px solid #ccc;
		width: 480px;
		min-height: 100px;
		padding: 10px;
	}
</style>
